import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from '@freelancer/components';
import {
  DatastoreProjectViewUsersModule,
  DatastoreSuperuserBidsModule,
  DatastoreSuperuserMilestonesModule,
  DatastoreSuperuserProjectViewUsersModule,
} from '@freelancer/datastore/collections';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { BidDetailComponent } from './tabs/project-overview/bid-information/bid-detail/bid-detail.component';
import { BidInformationComponent } from './tabs/project-overview/bid-information/bid-information.component';
import { MilestoneItemStatusComponent } from './tabs/project-overview/milestones-information/milestone-item-status/milestone-item-status.component';
import { MilestonesInformationComponent } from './tabs/project-overview/milestones-information/milestones-information.component';
import { UserMetadataComponent } from './tabs/project-overview/user-metadata/user-metadata.component';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DatastoreProjectViewUsersModule,
    DatastoreSuperuserBidsModule,
    DatastoreSuperuserProjectViewUsersModule,
    DatastoreSuperuserMilestonesModule,
    MatTooltipModule,
    PipesModule,
    TrackingModule,
    UiModule,
  ],
  declarations: [
    BidDetailComponent,
    BidInformationComponent,
    MilestonesInformationComponent,
    MilestoneItemStatusComponent,
    UserMetadataComponent,
  ],
  exports: [
    BidInformationComponent,
    MilestonesInformationComponent,
    UserMetadataComponent,
  ],
})
export class ProjectDetailsSharedModule {}
